var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a4.224 4.224 0 0 0-4.219 4.219A4.224 4.224 0 0 0 8 8.437a4.224 4.224 0 0 0 4.219-4.218A4.224 4.224 0 0 0 8 0ZM13.249 11.194a6.014 6.014 0 0 0-4.312-1.819H7.063a6.014 6.014 0 0 0-4.312 1.819A6.148 6.148 0 0 0 .97 15.53c0 .26.21.469.469.469h13.124c.26 0 .47-.21.47-.469 0-1.63-.634-3.17-1.783-4.337Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUser;